import { ActionPlanFocus } from '../ActionPlanFocus/ActionPlanFocus';
import { ActionPlanSelection } from '../ActionPlanSelection/ActionPlanSelection';
import { ActionPlanThankYou } from '../ActionPlanThankYou';
import { ActionPlanAggregated } from '../ActionPlanAggregated/ActionPlanAggregated';
import type { ActionPlanStep } from '../../logic/ActionPlanStepResolver';
import type { ActionPlanChoices } from '../../logic/ActionPlanFlowManager';

export interface ActionPlanContentProps {
  step: ActionPlanStep;
  surveyUuid: string;
  selectedCategoryId: number;
  submittedChoices?: ActionPlanChoices;
  onFocusContinue: (categoryId: number) => void;
  onSelectionSuccess: (choices?: ActionPlanChoices) => void;
  onSelectionBack: () => void;
  onBackToResults: () => void;
}

export const ActionPlanContent = ({
  step,
  surveyUuid,
  selectedCategoryId,
  submittedChoices,
  onFocusContinue,
  onSelectionSuccess,
  onSelectionBack,
  onBackToResults,
}: ActionPlanContentProps) => {
  switch (step) {
    case 'focus':
      return (
        <ActionPlanFocus
          surveyUuid={surveyUuid}
          onContinue={onFocusContinue}
        />
      );

    case 'selection':
      return (
        <ActionPlanSelection
          surveyUuid={surveyUuid}
          categoryId={selectedCategoryId}
          onSuccess={onSelectionSuccess}
          onBack={onSelectionBack}
        />
      );

    case 'thankYou':
      return <ActionPlanThankYou choices={submittedChoices} onBackToResults={onBackToResults} />;

    case 'aggregated':
      return (
        <ActionPlanAggregated
          surveyUuid={surveyUuid}
          onBackToResults={onBackToResults}
        />
      );

    default:
      return null;
  }
};
